import React, { useEffect } from "react";

import GreyTable from '../../../../components/Tables/GreyTable';
import { BalParty365, DlvParty365, InwDatetail, resetBalParty365 } from '../../../../Redux/Slice/Grey/PartyProfile/PartyProfileSlice';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const Balance365 = ({ selectedProduction, selectedAccount }) => {

  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );
  const { theme } = useTheme();
  const isdark = theme;


  const { Balance365Data } = useSelector((state) => state.PartyProfileSlice);

  const monthOrder = [
    "April", "May", "June", "July", "August", "September",
    "October", "November", "December", "January", "February", "March"
  ];

  const Date = [
    "Billing",
    "1", "2", "3", "4", "5", "6", "7", "8", "9", "10",
    "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
    "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31",
  ];

  const columns = [
    // { Header: "Chart", accessor: "chartButton", width: "60px" },
    { key: "srNumber", label: "Sr. No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Month", label: "Month", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Billing", label: "Balance Meter", format: true, align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    ...Array.from({ length: 31 }, (_, i) => ({
      key: `${i + 1}`,
      label: `${i + 1}`,
      width: 125,
      format: true,
      align: "right",
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5

    })),
  ];

  useEffect(() => {
    dispatch(resetBalParty365())
    dispatch(BalParty365({
      selectedIds: selectedProduction ? selectedProduction.toString() : "",
      PARTYWISEIds: selectedAccount ? selectedAccount.toString() : ""
    }));
  }, [selectedProduction, selectedAccount]);

  const formattedRows = Balance365Data?.Bal365
    ?.slice()
    ?.sort((a, b) =>
      (monthOrder.indexOf(a.Month) !== -1 ? monthOrder.indexOf(a.Month) : 99) -
      (monthOrder.indexOf(b.Month) !== -1 ? monthOrder.indexOf(b.Month) : 99)
    )
    ?.map((row, index, arr) => {
      const totalLength = arr.length.toString().length;
      const formattedRow = {
        // srNumber: (index + 1).toString().padStart(totalLength, "0"),
        id: index,
        ...row,
      };

      if (formattedRow.Month) {
        formattedRow.Month = formattedRow.Month.split("'")[0];
      }

      Date.forEach((accessor) => {
        formattedRow[accessor] = row[accessor];
      });

      return formattedRow;
    });

  if (Balance365Data === null) {

    return (
      <div className="flex justify-center items-center text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <Row>
        <Col>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                color:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour8,
                padding: "14px",
              }}
            >
              <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px" ,fontWeight:"700"}}>
                BALANCE 365  
              </h2>
            </div>
            <div><GreyTable columns={columns} data={formattedRows} iscolourDark={iscolourDark}
              iscolour={iscolour} /></div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
